	<template>
		<div class="ai_container">
			<Header :onPrev="handlePrev" />
			<div class="ai_wrapper">
				<h3 class="body_4">
					견적 확인하고<br /><b class="heading_5">합리적으로 수리</b> 받으세요
				</h3>
				<div class="confirm_content_wrapper">
					<div class="estimate_wrapper">
						<p class="heading_7">예상 견적</p>
						<ul>
							<li v-for="item in partsList" :key="item.label">
								<p>{{item.partDescription}}</p>
								<p>{{item.maskingAmt}}</p>
							</li>
						</ul>
					</div>
					<div class="estimate_wrapper">
						<ul>
							<li v-for="item in laborList" :key="item.label">
								<p>{{item.laborDescription}}</p>
								<p>{{item.maskingAmt}}</p>
							</li>
						</ul>
					</div>
					<img src="/static/images/ai/gradient_white.png" />
				</div>
				<div class="total_estimate">
					<strong class="heading_8 f_primary_1">최종견적</strong>
					<strong class="heading_8 f_primary_1">결제 이후 확인할 수 있어요</strong>
				</div>
				<div class="estimate_caution_wrapper">
					<b class="heading_10">유의사항</b>
					<p class="body_10">산출된 AI견적은 업계 평균 공임으로 계산 되었으며, 공업사에 따라 최종
					수리비용은 차이가 발생 될 수 있어요.</p>
				</div>
			</div>
			<BottomFloatButton label="결제하고 견적 확인하기" :onClick="handleToastShow" :isFull="false" />
			<Alert
				:isVisible="isAlert.isOpenAlert"
				:title="isAlert.title"
				:primaryText="'돌아가기'"
				:onClickPrimary="handleAlertClose"
				/>
		</div>
	</template>

<script>
import Vue from 'vue'
import Header from '../../components/ai/AiHeader.vue'
import BottomFloatButton from '../../components/ai/AiBottomFloatButton.vue'
import AppConfig from '@/config'
import Alert from '@/components/ai/AiAlert.vue'

export default {
	name: 'AiConfirm',
	components: {
		Header,
		BottomFloatButton,AppConfig,Alert
	},
	computed:{
		estimateSeq(){
			return Vue.$sessionStorage.get('redirectseq');
		},

	},
	data(){
		return{
			partsList:{},
			laborList:{},
			isAlert:{
				isOpenAlert:false,
				title:''
			},

		}
	},
	methods: {
		handlePrev() { },
		handleToastShow(){
			this.$router.push({name:'AiPayment'});
		},
		handleAlertClose(){
			this.isAlert.isOpenAlert = false;
			this.$router.push({name:'AiEstimateList'});
		}
	},
	mounted(){
		var params = {
			estimateSeq: this.estimateSeq
		}
		Vue.httpClient
		.post('/m/ai/dat/estimate/confirmCheck', params)
		.then(response => {
			if(response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS){
				if (response.data.result) {
					const result = response.data.result
					const estiCode = result.estimateItem.estimateStatusCode
					if(estiCode === '30' || estiCode === '40'){
						this.$router.push({name:'AiEstimate'});
					} else {
						this.partsList = result.listParts
						this.laborList = result.listLaber
					}
				}
			} else {
				throw new Error('response')
			}
		})
		.catch((e)=>{
			if(e.data.result){
				this.isAlert.isOpenAlert = true;
				this.isAlert.title = e.data.result.message;
			}
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/views/ai/AiConfirm.vue